import {
	Box,
	createStyles,
	Group,
	Image,
	Stack,
	UnstyledButton,
} from '@mantine/core';
import { Badge, Button, Icon, Text } from '@repo/foundations';
import { useCallback } from 'react';
import { COVER_DATA_SCANNING_MAPPING } from './constants';
interface PoliciesBannerProps {
	onCreatePolicy: () => void;
	onSeeHowItWorks: () => void;
	onDismiss: () => void;
}

const useStyles = createStyles(
	(theme, { backgroundImageUrl }: { backgroundImageUrl: string }) => ({
		root: {
			backgroundImage: `url(${backgroundImageUrl})`,
			backgroundSize: 'cover',
			width: '100%',
			height: 210,
			padding: theme.spacing.lg,
			alignItems: 'flex-start',
			gap: theme.spacing.sm,
			borderRadius: theme.other.borderRadius.md,
			overflow: 'hidden',
			flexDirection: 'column',
			flexFlow: 'nowrap',
		},
		contentContainer: {
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'flex-start',
			alignSelf: 'stretch',
			flex: '1 0 0',
			gap: theme.spacing.sm,
		},
		badge: {
			width: 'fit-content',
		},
		textContainer: {
			gap: 0,
			maxWidth: 470,
		},
		bannerImageContainer: {
			display: 'flex',
			alignItems: 'flex-start',
			justifyContent: 'flex-start',
			gap: theme.spacing.sm,
		},
	})
);

export function PoliciesBanner({
	onCreatePolicy,
	onSeeHowItWorks,
	onDismiss,
}: PoliciesBannerProps) {
	const backgroundImageUrl =
		COVER_DATA_SCANNING_MAPPING['background-image.png'];
	const bannerImageUrl = COVER_DATA_SCANNING_MAPPING['banner-image.png'];

	const { classes } = useStyles({ backgroundImageUrl });

	const handleSeeHowItWorks = useCallback(() => {
		onSeeHowItWorks();
	}, [onSeeHowItWorks]);

	return (
		<Group className={classes.root} position="apart">
			<Stack spacing="sm" className={classes.contentContainer}>
				<Badge
					w="fit-content"
					backgroundColor="fill/transparent-secondary/default"
				>
					<Text size="xs" color="text/primary/default" fw={450}>
						New: Data scanning policies
					</Text>
				</Badge>
				<Stack className={classes.textContainer}>
					<Text weight="bold" size="md">
						See what your data&apos;s been hiding
					</Text>
					<Text size="sm">
						Our intelligent scanning policies automatically detect PII,
						sensitive data, and compliance issues across your entire data
						ecosystem — then alert you instantly so you can act fast.
					</Text>
				</Stack>
				<Group spacing="xs">
					<Button
						variant="default"
						size="sm"
						leftIconName="playerPlay"
						onClick={handleSeeHowItWorks}
					>
						See how it works
					</Button>
					<Button variant="primary" size="sm" onClick={onCreatePolicy}>
						Create policy
					</Button>
				</Group>
			</Stack>
			<Box className={classes.bannerImageContainer}>
				<Image src={bannerImageUrl} width={'auto'} height={208} />
				<UnstyledButton onClick={onDismiss}>
					<Icon
						size="md"
						name="x"
						fillColor="icon/inverse/default"
						color="icon/inverse/default"
					/>
				</UnstyledButton>
			</Box>
		</Group>
	);
}
